import React from 'react'
import './ICTinfrastructure.css'

const DataCenter = () => {
  return (
    <div className="ICT_Hero flex justify-center items-center"><div className="  text-white  text-center ">
    <h1 className="text-[5rem] ">Data Center <br /> Services & Solutions</h1>
    
  </div></div>
  )
}

export default DataCenter